/**
 * Fish tag badge rules shared by box labels v2 print and on-screen UI.
 */

/** Fish tag badge size (CSS px) — single knob for circles and pills. */
export const FISH_TAG_BADGE_SIZE_PX = 42

/** Tags at or above this length render as rounded pills instead of circles. */
export const FISH_TAG_PILL_MIN_CHARS = 4

/** Font size (CSS px) inside circles. */
export const FISH_TAG_CIRCLE_FONT_SIZE_PX = 16

/** Font size (CSS px) inside pills. */
export const FISH_TAG_PILL_FONT_SIZE_PX = 13

/** Long fish tag pills show this many characters, then "..." (e.g. 1234567890...). */
export const FISH_TAG_PILL_VISIBLE_CHARS = 10

/** Split fish tags on comma or slash; zero-pad single digits to two. */
export function splitBoxLabelFishTags(fishTag) {
    return String(fishTag ?? "")
        .split(/[,/]+/)
        .map((tag) => tag.trim())
        .filter(Boolean)
        .map((tag) => (/^\d$/.test(tag) ? `0${tag}` : tag))
}

export function isLongFishTag(tag) {
    return String(tag ?? "").trim().length >= FISH_TAG_PILL_MIN_CHARS
}

export function formatFishTagPillText(tag) {
    const clean = String(tag ?? "").trim()
    if (clean.length <= FISH_TAG_PILL_VISIBLE_CHARS) {
        return clean
    }
    return `${clean.slice(0, FISH_TAG_PILL_VISIBLE_CHARS)}...`
}

/**
 * Comma-joined tags for compact pill display (no spaces).
 * @param {string[]} tags
 */
export function formatFishTagCommaJoin(tags) {
    const list = Array.isArray(tags) ? tags.map((t) => String(t ?? "").trim()).filter(Boolean) : []
    return list.join(",")
}

/**
 * If we have too many tags to render as individual circles/pills, we fall back to
 * a single pill with comma-separated tags (and the normal pill truncation rule).
 */
export function formatFishTagCommaPillText(tags) {
    const list = Array.isArray(tags) ? tags.map((t) => String(t ?? "").trim()).filter(Boolean) : []
    return formatFishTagPillText(list.join(", "))
}
